export const putSubscription = (subscription) => (dispatch) => {
  if (subscription)
    dispatch({ type: 'SET_SUBSCRIPTION', payload: subscription })
}
